import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  StackDivider,
  Text,
  useToast,
  VStack
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsCheck, BsPlus } from "react-icons/bs";
import { RiSearch2Line } from "react-icons/ri";
import { IProgramModule } from "../../../models/admin/programs/module.model";
import program_moduleService from "../../../services/program_service/program_module.service";
import programsService from "../../../services/program_service/programs.service";
import { EmptySearchResult } from "../../EmptySearchResult";

export const AddModulesToProgramModal: React.FC<any> = ({
  isOpened,
  onClosed,
  selectedAssessmentId,
  programId,
  updateRecord,
}: {
  isOpened: any;
  onClosed: any;
  selectedAssessmentId: any;
  programId: string;
  updateRecord: any;
}) => {
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [modules, setmodules] = useState<IProgramModule[]>([]);
  const [modulesMemo, setmodulesMemo] = useState<IProgramModule[]>([]);
  const [filteredmodules, setFilteredmodules] = useState<IProgramModule[]>([]);
  const [pickedmodules, setPickedmodules] = useState<IProgramModule[]>([]);
  const [hasPosting, setHasPosting] = useState<boolean>(true);
  const [programDiscipline, setProgramDiscipline] = useState([]);
  const [programSpecialization, setProgramSpecialization] = useState([]);
  const [programDisciplineId, setProgramDisciplineId] = useState<number | any>();
  const [programSpecializationId, setProgramSpecializationId] = useState<number | any>();
  const [isEnrolling, setIsEnrolling] = useState(false);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  useEffect(() => {
    program_moduleService.getModules().then((res) => {
      const modules: IProgramModule[] = res.data;
      setFilteredmodules(modules);
      setmodules(modules);
      setLoading(false);
    });
    programsService.getDisciplines().then(
      (res) => {
        setProgramDiscipline(res.data);
      }
    )
    programsService.getSpecializations().then(
      (res) => {
        setProgramSpecialization(res.data);
      }
    )
  }, [programId]);



  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredmodules(modules);
    } else {
      if (modules) {
        const filtered = modules.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredmodules(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const pickUser = (index: number) => {
    const module = filteredmodules?.at(index);
    const indexOfModule = pickedmodules?.findIndex(
      (each) => each.id == module?.id
    );

    if (indexOfModule >= 0) {
      pickedmodules?.splice(indexOfModule, 1);
      setPickedmodules([...pickedmodules]);
    } else {
      setPickedmodules([
        module as IProgramModule,
        ...(pickedmodules as IProgramModule[]),
      ]);
    }
  };

  const isPicked = (index: number): boolean => {
    const module = filteredmodules?.at(index);

    const moduleIndex = pickedmodules?.findIndex(
      (each) => each.id === module?.id
    );

    return moduleIndex >= 0 ? true : false;
  };

  const assignCourseToModule = async () => {
    setIsEnrolling(true);
    const resLength = [];
    for (let index = 0; index < pickedmodules.length; index++) {
      const data = {
        program_id: programId,
        module_id: pickedmodules[index].id.toString(),
        assessment_category_id: selectedAssessmentId,
        has_posting: hasPosting,
        program_discipline_id: programDisciplineId.toString(),
        program_specialization_id: programSpecializationId.toString(),
        default_centre_id: "1",
        status: '2'
      };
      const response = await programsService.addModuleToProgram(data);
      resLength.push(response);
    }

    try {
      if (resLength.length == pickedmodules.length) updateRecord();
      setPickedmodules([]);
      onClosed();

      toast({
        title: "Add Module to Program",
        description: resLength[0].message,
        status: "success",
        duration: 3000,
      });
    } catch (error) {
      toast({
        title: "Add Module to Program",
        description: "Something went Wrong. Try again later",
        status: "error",
      });
    } finally {
      setIsEnrolling(false);
    }
  };

  const closeModal = () => {
    setPickedmodules([]);

    setmodules(modulesMemo);

    onClosed();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpened}
        onClose={closeModal}
        scrollBehavior="inside"
        motionPreset="slideInRight"
        size={"lg"}
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={6}>
          <ModalHeader color="brand.2" fontSize={22}>
            Add module to program
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={6}>
            <Flex justifyContent="space-between" alignItems="center" mb={3}>
              <InputGroup color="brand.subtitle" width={"80%"} bg="white">
                <Input
                  placeholder="Search modules"
                  onChange={(e) => handleSearchChange(e)}
                  fontSize={12}
                  size="sm"
                />

                <InputRightElement
                  h="1.9rem"
                  pointerEvents="none"
                  children={<RiSearch2Line size="0.8rem" />}
                />
              </InputGroup>
            </Flex>

            {pickedmodules.length > 0 && (
              <Box mb={2} justifyContent="center" display="flex">
                <Text fontSize={12} color="brand.2">
                  {" "}
                  {pickedmodules?.length}{" "}
                  <Box color="brand.subtitle" as="span">
                    {" "}
                    Modules selected{" "}
                  </Box>
                </Text>
              </Box>
            )}

            <Divider />

            <VStack
              mt={4}
              divider={<StackDivider borderColor="gray.200" />}
              spacing={4}
              align="stretch"
            >
              {isSearchEmpty ? (
                <EmptySearchResult />
              ) : (
                filteredmodules?.map((each, index) => (
                  <Flex key={index} justifyContent="space-between">
                    <HStack>
                      <Avatar size="xs" name={`${each.name} `} />
                      <Box>
                        <Text fontSize={11}>{`${each.name} `}</Text>
                      </Box>
                    </HStack>
                    <Box
                      width={6}
                      color={isPicked(index) ? "#02A356" : "#959595"}
                      height={6}
                      borderRadius={20}
                      border="dotted"
                      justifyContent="center"
                      alignItems="center"
                      cursor="pointer"
                      onClick={() => pickUser(index)}
                    >
                      <Flex
                        direction="column"
                        justifyContent="center"
                        height="100%"
                        alignItems="center"
                        fontSize={16}
                      >
                        {isPicked(index) ? <BsCheck /> : <BsPlus />}
                      </Flex>
                    </Box>
                  </Flex>
                ))
              )}
            </VStack>
            <FormControl mt={4}>
              <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                Does this module have posting ?
              </FormLabel>
              <HStack spacing={4} alignItems="center">
                <Checkbox
                  size="sm"
                  colorScheme="red"
                  isChecked={hasPosting===true}
                  onChange={(e) => setHasPosting(e.target.checked)}
                  onClick={()=>setHasPosting(true)}
                >
                  Yes
                </Checkbox>
                <Checkbox
                  size="sm"
                  colorScheme="red"
                  isChecked={hasPosting===false}
                  onChange={(e) => setHasPosting(!e.target.checked)}
                  onClick={()=>setHasPosting(false)}
                >
                  No
                </Checkbox>
              </HStack>
            </FormControl>

            <FormControl
              mt={4}
            >
              <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                Select Specialization:
              </FormLabel>
              <Select
                variant="outline"
                bg="inputText.500"
                size="sm"
                placeholder="Select program specialization"
                value={programSpecializationId}
                name="programSpecializationId"
                onChange={(e) => setProgramSpecializationId(e.target.value)}
                fontSize="14px"
                color="brand.subtitle"
              >
                {
                  programSpecialization.map((each: any, index: number) => (
                    <option key={index} value={each.id}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))
                }

              </Select>

            </FormControl>
            <FormControl
              mt={4}
            >
              <FormLabel fontWeight="700" color="#757575" fontSize="14px">
                Select Discipline:
              </FormLabel>
              <Select
                variant="outline"
                bg="inputText.500"
                size="sm"
                placeholder="Select program discilpline"
                value={programDisciplineId}
                name="programDisciplineId"
                onChange={(e) => setProgramDisciplineId(e.target.value)}
                fontSize="14px"
                color="brand.subtitle"
              >
                {
                  programDiscipline.map((each: any, index: number) => (
                    <option key={index} value={each.id}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))
                }
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            {pickedmodules.length > 0 && (
              <Button
                colorScheme="red"
                mr={3}
                size="xs"
                isLoading={isEnrolling}
                fontSize={11}
                borderRadius={2}
                px={5}
                onClick={() => {
                  assignCourseToModule();
                }}
              >
                {" "}
                Done{" "}
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
